import getPositionByPositionKey from "./getPositionByPositionKey";
import { positionKeys } from "./publicKeys";

export default function getPlayerInfoFilledWithDummy(playerInfo) {

    const dummyPlayer = {
        "playerName":"더미 플레이어",
        "originalOvr":0,
        "stars":1,
        "team":"더미",
        "year":null,
        "position":"2B",
        "type":"더미",
        "setDeckScore":12,
        "originalStates":{
            "level":0,
            "s1":0,
            "s2":0,
            "s3":0,
            "s4":0,
            "s5":0,
            "s6":0
        },
        "isPitcher":false,
        "level": 0,
        isAwaken: false,
        isFa: null,
        trainedStates: { level: 0, s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        specialTrainedStates: { level: 0, s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        positionTrainedStates: { level: 0, s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        positionTrainedAdditionalStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        enforcedStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        awakenStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        setDeckStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        synergyStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
        faStates: {s1: 0, s2: 0, s3: 0, s4: 0, s5: 0, s6: 0 },
    }

    let newPlayerInfo = {...playerInfo};

    for (let positionKey of positionKeys) {
        const player = newPlayerInfo[positionKey];
        if (!player) {
            newPlayerInfo = {
                ...newPlayerInfo,
                [positionKey]: {
                    ...dummyPlayer,
                    position: getPositionByPositionKey(positionKey),
                    isPitcher: positionKey.includes('P')
                }
            };
        }
    }

    return newPlayerInfo;
}